<script>
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import Multiselect from "vue-multiselect";
import {swal, imageError} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Image from '../../../model/image.js';
import { dataURLtoFile } from '../../../helpers/helper_func'
import appConfig from "@/app.config";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import InputTag from 'vue-input-tag';

export default {
  components: { Multiselect, AlertError, Cropper, InputTag },
  data() {
    return {
      // limit tag
      limit:10,

      //Page errors.
      errors: [],
      
      image: new Image,
      acceptFile: appConfig.acceptFile.image,
      aspectRatio: Number(appConfig.aspectRatio.image),
      submitadd: false,
      loadingButton: false,
    };
  },
  validations: {
     image: {
      title_ar: {required: requiredIf(function (){ return this.checkLocale('ar'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_en: {required: requiredIf(function (){ return this.checkLocale('en'); }), minLength: minLength(2), maxLength: maxLength(300) },
      title_fa: {required: requiredIf(function (){ return this.checkLocale('fa'); }), minLength: minLength(2), maxLength: maxLength(300) },
      image: {required},
      locales: {required},
      albums: {required}
    },
  },
  computed:{
    ...mapGetters('album', {albums: 'getAlbums'}),
  },
  methods: {
    ...mapActions("image", ['add']),
    imageError,
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    chnageFile(e){
      this.image.Image = e.target.files.length > 0 ? e.target.files[0] : null;
    },
    setCroppedImage(){
      const result = this.$refs.cropper.getResult();
      const data64 = result.canvas.toDataURL(this.image.image.type);
      this.image.image = dataURLtoFile(data64, this.image.image.value);
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.image.reset()
    },
    checkLocale(locale){
      return this.image.locales.includes(locale);
    },
    checkValidate(){
      return !this.$v.image.locales.$error &&
        (!this.checkLocale('ar') || !this.$v.image.title_ar.$error) && 
        (!this.checkLocale('en') || !this.$v.image.title_en.$error) && 
        (!this.checkLocale('fa') || !this.$v.image.title_fa.$error) &&
        !this.$v.image.image.$error &&
        !this.$v.image.albums.$error
    },
    formAddImage(published = false) {
      this.submitadd = true;
      this.$v.$touch();
      if(!this.checkValidate()) return;

      // to form submit after this
      this.loadingButton = true
      this.errors = [];
      
      this.image.published = published
      this.setCroppedImage()

      this.add(this.image.toFormData())
      .then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    unitTest(){
      this.image.locales = ['ar', 'en', 'fa']
      this.image.albums = this.albums
      this.image.title_ar = 'image test title ar'
      this.image.title_en = 'image test title en'
      this.image.title_fa = 'image test title fa'
      this.image.content_ar = '<h2>image Test Content ar</h2>'
      this.image.content_en = '<h2>image Test Content en</h2>'
      this.image.content_fa = '<h2>image Test Content fa</h2>'
    },
  },
  mounted(){
    //in locale dev.
    if(process.env.NODE_ENV == "development") {
      this.unitTest()
    }
  }
};
</script>


<template>

  <b-form ref="form">
    <AlertError :errors="errors"></AlertError>

    <div class="row mt-3">

      <b-form-group class="col-md-12 mb-3" label="لغة الصورة :">
        <b-form-checkbox class="dis-inline" v-model="image.locales" value="ar" plain>عربي</b-form-checkbox>
        <b-form-checkbox class="dis-inline" v-model="image.locales" value="en" plain>انكليزي</b-form-checkbox>
        <!-- <b-form-checkbox class="dis-inline" v-model="image.locales" value="fa" plain>فارسي</b-form-checkbox> -->
         <div v-if="submitadd && $v.image.locales.$error" class="invalid-check">
          <span v-if="!$v.image.locales.required"> يجب اختيار لغة واحدة على الاقل </span>
        </div>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="اضافة الصورة : " label-for="image" >
        <div class="custom_file">
          <b-form-file ref="image" id="image" v-model="image.image" :accept="acceptFile" :class="{ 'is-invalid': submitadd && $v.image.image.$error }"  @change="chnageFile" placeholder="اختر صورة" ></b-form-file>
          <div v-if="submitadd && $v.image.image.$error" class="invalid-feedback">
            <span v-if="!$v.image.image.required"> هذا الحقل الزامي </span>
          </div>
        </div>
        
        <cropper v-if="image.picture" :src="image.picture" @error="imageError" class="cropper" :auto-zoom="true" ref="cropper"
          :stencil-props="{ aspectRatio: aspectRatio }"
        ></cropper>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="البوم الصورة :" label-for="albums" >
          <multiselect 
            id="albums" 
            select-label="اختر الالبوم"
            placeholder="اختر احد الالبومات" 
            deselect-label="اظغط هنا لمسح الاختيار"
            selected-label="تم اختياره"
            :class="{ 'is-invalid': submitadd && $v.image.albums.$error }"
            v-model="image.albums"
            :options="albums"
            track-by="id"
            label="Title"
            :close-on-select="false"
            :clear-on-select="false"
            :multiple="true">
            </multiselect>
        <div v-if="submitadd && $v.image.albums.$error" class="invalid-feedback">
          <span v-if="!$v.image.albums.required"> يجب اختيار البوم واحد على الاقل </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="عنوان الصورة : ( عربي )" label-for="title_ar" >
        <b-form-input id="title_ar" v-model.trim="image.title_ar" :class="{ 'is-invalid': submitadd && $v.image.title_ar.$error }" placeholder="ادخل عنوان الصورة" type="text" ></b-form-input>
        <div v-if="submitadd && $v.image.title_ar.$error" class="invalid-feedback">
          <span v-if="!$v.image.title_ar.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.image.title_ar.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.image.title_ar.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('ar')" class="col-md-12 mb-3 class_ar" label="وصف الصورة : ( عربي )" label-for="description_ar" >
        <textarea id="description_ar" v-model="image.description_ar" class="form-control" rows="5" ></textarea>
      </b-form-group>

      <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="عنوان الصورة : ( انجليزي )" label-for="title-en" >
        <b-form-input id="title-en" v-model.trim="image.title_en" :class="{ 'is-invalid': submitadd && $v.image.title_en.$error }" placeholder="ادخل عنوان الصورة" type="text" ></b-form-input>
        <div v-if="submitadd && $v.image.title_en.$error" class="invalid-feedback">
          <span v-if="!$v.image.title_en.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.image.title_en.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.image.title_en.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('en')" class="col-md-12 mb-3 class_en" label="وصف الصورة : ( انجليزي )" label-for="description_en" >
        <textarea id="description_en" v-model="image.description_en" class="form-control" rows="5" ></textarea>
      </b-form-group>

      <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="عنوان الصورة : ( فارسي )" label-for="title-fa" >
        <b-form-input id="title-fa" v-model.trim="image.title_fa" :class="{ 'is-invalid': submitadd && $v.image.title_fa.$error }" placeholder="ادخل عنوان الصورة" type="text" ></b-form-input>
        <div v-if="submitadd && $v.image.title_fa.$error" class="invalid-feedback">
          <span v-if="!$v.image.title_fa.required"> هذا الحقل الزامي </span>
          <span v-if="!$v.image.title_fa.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
          <span v-if="!$v.image.title_fa.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 300 حرف على الاكثر . </span>
        </div>
      </b-form-group>

      <b-form-group v-if="checkLocale('fa')" class="col-md-12 mb-3 class_fa" label="وصف الصورة : ( فارسي )" label-for="description_fa" >
        <textarea id="description_fa" v-model="image.description_fa" class="form-control" rows="5" ></textarea>
      </b-form-group>

      <b-form-group class="col-md-12 mb-3" label="الكلمات المفتاحية :" label-for="tag" >
        <input-tag class="form-control" placeholder="اضافة" :limit="limit" validate="" v-model="image.tags"></input-tag>
      </b-form-group>

    </div>

    <div class="mt-3">
      <hr>
      <b-button :disabled="loadingButton" @click="formAddImage(false)" variant="primary" type="button" class="me-2"> 
        <b-spinner v-if="loadingButton && !image.published" small></b-spinner>
        <span v-else><i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ</span>
      </b-button>

       <b-button :disabled="loadingButton" @click="formAddImage(true)" variant="success" type="button"> 
        <b-spinner v-if="loadingButton && image.published" small></b-spinner>
        <span v-else><i class="bx bx-paper-plane font-size-16 align-middle me-2"></i>نشر</span>
      </b-button>
    </div>

  </b-form>

</template>